import StatusBadge from "../../midpoint/intelligence/StatusBadge";

const TONES = {
  low: "confirmed",
  moderate: "medium",
  elevated: "medium",
  high: "disputed",
  unknown: "neutral",
};

const RISK_COPY = {
  low: "Low current weather signal",
  moderate: "Moderate weather signal",
  elevated: "Elevated weather concern",
  high: "High weather concern",
  unknown: "Insufficient fresh data",
};

const WeatherRiskBadge = ({ level, labelPrefix }) => {
  const normalized = level || "unknown";
  const label =
    labelPrefix != null
      ? `${labelPrefix}: ${normalized.replace(/_/g, " ")}`
      : RISK_COPY[normalized] || normalized.replace(/_/g, " ");

  return <StatusBadge label={label} tone={TONES[normalized] || "neutral"} />;
};

export default WeatherRiskBadge;
